import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </Provider>
);

function attachTypingListeners() {
  const selector = 'input[type="text"], input[type="email"], input[type="password"], input:not([type]), textarea, [contenteditable="true"]';

  function bindTo(el) {
    if (!el) return;
    const onInput = () => {
      try {
        if (el.value && el.value.length > 0) el.classList.add('typing');
        else el.classList.remove('typing');
      } catch (e) {
        if (el.textContent && el.textContent.trim().length > 0) el.classList.add('typing');
        else el.classList.remove('typing');
      }
    };
    const onFocus = () => el.classList.add('typing');
    const onBlur = () => {
      try {
        if (!el.value || el.value.length === 0) el.classList.remove('typing');
      } catch (e) {
        if (!el.textContent || el.textContent.trim().length === 0) el.classList.remove('typing');
      }
      el.classList.remove('typing');
    };

    el.addEventListener('input', onInput);
    el.addEventListener('focus', onFocus);
    el.addEventListener('blur', onBlur);

    onInput();
  }

  document.querySelectorAll(selector).forEach(bindTo);

  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(selector)) bindTo(node);
        node.querySelectorAll && node.querySelectorAll(selector).forEach(bindTo);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(attachTypingListeners, 50);
  } else {
    window.addEventListener('DOMContentLoaded', () => setTimeout(attachTypingListeners, 50));
  }
}

